import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createBlock(_component_v_overlay, {
    style: {"z-index":"9999"},
    "scroll-strategy": "none",
    class: "align-center justify-center",
    "model-value": _ctx.loadingSpinnerState.visible
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_progress_circular, {
        size: "64",
        color: "primary",
        indeterminate: ""
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}